module.exports = __webpack_public_path__ + "static/media/cleverpy-logo.a230b97f.jpg";